import { createContext, useContext, useState } from "react";

const DwhAppContext = createContext(null);

export const DwhContextProvider = ({ children }) => {
    const [topMcatsCities, setTopMcatsCities] = useState({ mcat: null, cities: null });
    
    return (
        <DwhAppContext.Provider
            value={{
                topMcatsCities,
                setTopMcatsCities,
            }}
        >
            {children}
        </DwhAppContext.Provider>
    );
};

export const useDwhAppContext = () => {
    const context = useContext(DwhAppContext);
    if (!context) {
        console.log("useDwhAppContext must be used within a DwhContextProvider");
    }
    return context;
};
